<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="center">For Peadar and Betty</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?695c50ac